import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const RiskScoreManagementStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1600px;
  } */

  .react-tabs__tab-panel {
    margin-top: 30px;

    .page-button {
      justify-content: flex-end;
    }
  }

  .table-wrapper {
    margin-top: 21px;
  }

  .table {
    .table-row {
      .category {
        flex: 0 0 38%;
        padding-left: 16%;
      }

      .actions {
        flex: 0 0 25%;
        padding: 14px 0 0 11.4%;
        justify-content: center;
        text-align: center;
      }

      .last-update {
        flex: 0 0 37%;
        justify-content: center;
        text-align: center;
      }

      &.header {
        .actions {
          padding: 0 14px;
        }

        .category {
          padding: 0 14px;
          justify-content: center;
          text-align: center;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
